import { CSSProperties } from 'react';
import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  landscape: CSSProperties;
  portrait: CSSProperties;
  imageContainer: FelaCSS;
  image: FelaCSS;
  row(index: number): CSSProperties;
  grid: FelaCSS;
  gridArea_PLP_Left: CSSProperties;
  gridArea_PLP_Right: CSSProperties;
  gridArea_LLL_Left: CSSProperties;
  gridArea_LLL_Right: CSSProperties;
  gridArea_PPP_Left: CSSProperties;
  gridArea_PPP_RightTop: CSSProperties;
  gridArea_PPP_RightBottom: CSSProperties;
  gridArea_LLP_LeftTop: CSSProperties;
  gridArea_LLP_LeftBottom: CSSProperties;
  gridArea_LLP_Right: CSSProperties;
  gridArea_PLL_Left: CSSProperties;
  gridArea_PLL_RightTop: CSSProperties;
  gridArea_PLL_RightBottom: CSSProperties;
  gridArea_LPP_Left: CSSProperties;
  gridArea_LPP_Right: CSSProperties;
  gridArea_LPL_Left: CSSProperties;
  gridArea_LPL_Right: CSSProperties;
  gridArea_LL_Left: CSSProperties;
  gridArea_LL_Right: CSSProperties;
  gridArea_PP_Left: CSSProperties;
  gridArea_PP_Right: CSSProperties;
  gridArea_LP_Left: CSSProperties;
  gridArea_LP_Right: CSSProperties;
  gridArea_PL_Left: CSSProperties;
  gridArea_PL_Right: CSSProperties;
}

const styles = (): IStyles => ({
  landscape: {
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    paddingBottom: 'calc(2 / 3 * 100%)',
  },
  portrait: {
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    paddingBottom: 'calc(4 / 3 * 100%)',
  },
  imageContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    paddingBottom: 0,
  },
  image: {
    position: 'relative',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  row: (index: number) => ({
    gridArea: `${index} / 1 / auto / auto`,
  }),
  grid: {
    display: 'grid',
    gap: 12,
    maxWidthMobile: {
      gap: 8,
    },
  },
  gridArea_PLP_Left: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_PLP_Right: {
    gridArea: '1 / 2 / auto / auto',
  },
  gridArea_LLL_Left: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_LLL_Right: {
    gridArea: '1 / 2 / auto / auto',
  },
  gridArea_PPP_Left: {
    gridArea: '1 / 1 / span 2 / span 2',
  },
  gridArea_PPP_RightTop: {
    gridArea: '1 / 3 / auto / auto',
  },
  gridArea_PPP_RightBottom: {
    gridArea: '2 / 3 / auto / auto',
  },
  gridArea_LLP_LeftTop: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_LLP_LeftBottom: {
    gridArea: '2 / 1 / auto / auto',
  },
  gridArea_LLP_Right: {
    gridArea: '1 / 2 / span 2 / auto',
  },
  gridArea_PLL_Left: {
    gridArea: '1 / 1 / span 2 / auto',
  },
  gridArea_PLL_RightTop: {
    gridArea: '1 / 2 / auto / auto',
  },
  gridArea_PLL_RightBottom: {
    gridArea: '2 / 2 / auto / auto',
  },
  gridArea_LPP_Left: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_LPP_Right: {
    gridArea: '1 / 2 / auto / auto',
  },
  gridArea_LPL_Left: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_LPL_Right: {
    gridArea: '1 / 2 / auto / span 2',
  },
  gridArea_LL_Left: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_LL_Right: {
    gridArea: '1 / 2 / auto / auto',
  },
  gridArea_PP_Left: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_PP_Right: {
    gridArea: '1 / 2 / auto / auto',
  },
  gridArea_LP_Left: {
    gridArea: '1 / 1 / auto / span 2',
  },
  gridArea_LP_Right: {
    gridArea: '1 / 3 / auto / auto',
  },
  gridArea_PL_Left: {
    gridArea: '1 / 1 / auto / auto',
  },
  gridArea_PL_Right: {
    gridArea: '1 / 2 / auto / span 2',
  },
});

export default styles;
